export default {
    mainMarkup: [
        '<div class="uwr-shifter-box-panel uwr-shifter-box-panel-left">',
        '<h3>{{titleLeft}}</h3>',
        '<div class="uwr-shifter-box-items"></div>',
        '</div>',
        '<div class="uwr-shifter-box-buttons">',
        '<button class="uwr-shifter-box-button uwr-shifter-box-button-right-shift" type="button"></button>',
        '<button class="uwr-shifter-box-button uwr-shifter-box-button-left-shift" type="button"></button>',
        '<button class="uwr-shifter-box-button uwr-shifter-box-button-right-shift-all" ',
        'type="button"></button>',
        '<button class="uwr-shifter-box-button uwr-shifter-box-button-left-shift-all" ',
        'type="button"></button>',
        '</div>',
        '<div class="uwr-shifter-box-panel uwr-shifter-box-panel-right">',
        '<h3>{{titleRight}}</h3>',
        '<div class="uwr-shifter-box-items"></div>',
        '</div>',
        '<div class="uwr-shifter-box-form-elements"></div>'
    ].join(''),

    itemListTablet: [
        '<ul>',
        '{{#items}}',
        '<li><input type="checkbox" id="{{id}}" name="" /><label for="{{id}}">{{name}}</label></li>',
        '{{/items}}',
        '</ul>'
    ].join(''),

    itemListDesktop: [
        '<select multiple>',
        '{{#items}}',
        '<option id="{{id}}">{{name}}</option>',
        '{{/items}}',
        '</select>'
    ].join(''),

    itemListFormElements: [
        '{{#items}}',
        '<input type="hidden" name="{{id}}" value="{{#selected}}on{{/selected}}" />',
        '{{/items}}'
    ].join('')
};


//////////////////
// WEBPACK FOOTER
// ./widgets/ShifterBox/js/shifterBoxView.js
// module id = 94
// module chunks = main